import "../style.css";
import React from 'react';
import PanelContent from "../components/PanelContent"

export default function Charge() {
  return (
    <PanelContent 
        id="charge_pannel"
        route="/charge"
        title="Recharge innovante"
        subtitle="Les batteries NMC au cœur de la performance du camion"
        description="Le camion capte l'énergie de la chaussée grâce au système ERS et la stocke dans ses batteries. Pour cela, il est équipé de 350kWh de batteries NMC (nickel-manganèse-cobalt) réparties sous sa cabine et en remplacement de ses réservoirs de carburant. Cette énergie lui permettra de quitter la route électrique avec une pleine charge et de poursuivre jusqu'à son point final de livraison."
        prev="/captation"
        next="/autonomy"
        txtbtn="ÉTAPE SUIVANTE"
    />
  );
}